enum AuthorizationStatusEnum {
	ALL = 'todos',
	SUCCESS = 'liberado',
	PENDING = 'pendente',
	REJECTED = 'indeferido',
	REGISTERED = 'registrado',
	FINISHED = 'concluido',
	UNDER_ANALYSIS = 'em analise',
}

const statusMap: Record<string, AuthorizationStatusEnum> = {
	CONCLUIDO: AuthorizationStatusEnum.FINISHED,
	PENDENTE: AuthorizationStatusEnum.PENDING,
	REGISTRADO: AuthorizationStatusEnum.REGISTERED,
	'EM ANALISE': AuthorizationStatusEnum.UNDER_ANALYSIS,
};

export {AuthorizationStatusEnum, statusMap};
